import { StatusItemProps } from "apis";
import { lazy } from "react";

export const PageAdminStatus = lazy(() => import("./List"));
export const PageAdminStatusCreate = lazy(() => import("./Add"));
export const PageAdminStatusUpdate = lazy(() => import("./Edit"));

export interface FormStatusValuesProps extends StatusItemProps { }